import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ModalRequest from '../modalRequest/modalRequest.vue'
import CollapseImageDetails from '../collapseImageDetails/collapseImageDetails.vue'
import AttachmentRequestRepository from '@/shared/http/repositories/realestate/attachmentRequestRepository'
import { loading, toast } from '@/shared/utils/UIHelper'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'

export default {
  components: {HeadDetailsGama, ModalRequest, CollapseImageDetails},
  name: 'AttachmentsDetails',
  props: ['attach', 'selectedSolicitacao'],
  data () {
    return {
      changeAngel: false,
      attachs: ['CNH'],
      haveData: true,
      dataFiles: [],
      dataGruposMidias: [],
      midiasSearch: [],
      search: '',
      searching: false,
      imgDetails: {},
      isPdf: false
    }
  },
  watch: {
    search (newvalue, old) {
      if (newvalue.length > 0) {
        this.searching = true
      } else {
        this.searching = false
      }
    }
  },
  mounted () {
    this.getFiles(this.selectedSolicitacao.id)
  },
  methods: {
    pesquisar () {
      this.midiasSearch = this.dataFiles.filter((Element) => Element.arquivo.descricao.toUpperCase().indexOf(this.search.toUpperCase()) > -1)
    },
    getFiles (request) {
      loading.push()
      AttachmentRequestRepository.GetAllByRequestId(request)
        .then(Response => {
          for (let i = 0; i < Response.data.data.length; i++) {
            this.dataFiles.push(Response.data.data[i])
          }
          this.getEnumTypes()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEnumTypes () {
      loading.push()
      AttachmentRequestRepository.GetEnum()
        .then(Response => {
          this.dataGruposMidias = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getTypes (type) {
      return this.dataFiles.filter(Element => Element.tipo === parseInt(type))
    },
    haveElements (arrayElements) {
      return arrayElements.length <= 0
    },
    imageDetails (obj, isPdf) {
      this.isPdf = isPdf
      this.imgDetails = obj
      this.$refs.modalAttachtmentDetails.show()
    },
    verificarEditar (e) {
      if (e === 0 || e === 1) {
        if (this.dataFiles.filter((Element) => Element.tipo === e).length >= 1) {
          return false
        } else {
          return true
        }
      }
      return true
    },
    SendImage (e) {
      loading.push()
      let UrlConvert = URL.createObjectURL(e.target.files[0])
      let obj = {
        data: e.target.files[0],
        url: UrlConvert
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let img = new FormData()
      img.append('img', obj.data)
      AttachmentRequestRepository.SendImg(this.data.id, parseInt(e.target.id.replace('addinput-', '')), img, conf)
        .then(Response => {
          this.dataFiles = []
          this.getFiles()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    downloadGrup () {
      let cheked = []
      let atLeastOneCheked = false
      for (let i = 0; i < this.dataGruposMidias.length; i++) {
        if (document.getElementById('check' + this.dataGruposMidias[i].enum).checked) {
          atLeastOneCheked = true
          break
        }
      }
      if (!atLeastOneCheked) {
        toast.error('Selecione um anexo para baixar')
        return
      }
      for (let i = 0; i < this.dataGruposMidias.length; i++) {
        if (document.getElementById('check' + this.dataGruposMidias[i].enum).checked) {
          cheked.push(this.dataGruposMidias[i].enum)
        }
      }
      var zip = new JSZip()
      for (let b = 0; b < cheked.length; b++) {
        let get = this.dataFiles.filter(Element => Element.tipo === cheked[b])
        if (get.length > 0) {
          let title = this.dataGruposMidias.filter(Element => Element.enum === cheked[b])
          let img = zip.folder(title[0].descricao)
          for (let z = 0; z < get.length; z++) {
            if ((get[z].arquivo.extensao === '.pdf')) {
              img.file(get[z].arquivo.descricao + z + '.pdf', get[z].arquivo.arquivo, {base64: true, createFolders: true})
            } else {
              img.file(get[z].arquivo.descricao + z + '.jpeg', get[z].arquivo.arquivo, {base64: true, createFolders: true})
            }
          }
        }
      }
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'anexos.zip')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/attachmentsDetails/attachmentsDetails.js